'use strict';


$(document).ready(function () {
    $('.plp-seo-content').each(function () {
        var content = $(this).find('.plp-seo-text-paragraph');
        var textLength = content.text().trim().length;
        var readMoreButton = $(this).find('.js-seo-button-readmore'); // Store the button in a variable

        // Check if readMoreButton exists
        if (!readMoreButton.length) {
            return; // Exit early if the button doesn't exist
        }

        const method = textLength > 1100 ? 'show' : 'hide'; // Determine the method based on text length
        readMoreButton[method]();
    });

    // Read More
    $('.js-seo-button-readmore').click(function () {
        $(this).parents('.plp-seo-content').addClass('is-open');
    });

    // Read Less
    $('.js-seo-button-readless').click(function () {
        $(this).parents('.plp-seo-content').removeClass('is-open');
    });
});

